const REACT_APP_DIMENSION_SYNC_TIMEOUT = process.env.REACT_APP_DIMENSION_SYNC_TIMEOUT || '5';
const REACT_APP_IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION;
const REACT_APP_MINUTES_TO_REFRESH_CPTI = process.env.REACT_APP_MINUTES_TO_REFRESH_CPTI || '5';
const REACT_APP_ROW_CHECKS_MIN = process.env.REACT_APP_ROW_CHECKS_MIN || '2';
const REACT_APP_SUPPORTED_BROWSERS_LINK = process.env.REACT_APP_SUPPORTED_BROWSERS_LINK;

export const config = {
  REACT_APP_DIMENSION_SYNC_TIMEOUT: parseInt(REACT_APP_DIMENSION_SYNC_TIMEOUT),
  REACT_APP_MINUTES_TO_REFRESH_CPTI: parseInt(REACT_APP_MINUTES_TO_REFRESH_CPTI),
  REACT_APP_ROW_CHECKS_MIN: parseInt(REACT_APP_ROW_CHECKS_MIN),
  REACT_APP_SUPPORTED_BROWSERS_LINK,
  isProduction: typeof REACT_APP_IS_PRODUCTION !== 'undefined',
};
